import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function normalizeURL(url: string) {
  // Check if the URL already starts with "http://" or "https://"
  if (!/^https?:\/\//.test(url)) {
    url = `https://${url}`; // Add "https://" if not present
  }
  return url;
}

export function getTimePassed(timestamp: string): number | string {
  const now = new Date();
  const past = new Date(timestamp);
  const timeDifference = now.getTime() - past.getTime(); // Difference in milliseconds

  const minutesPassed = timeDifference / (1000 * 60); // Convert to minutes
  const hoursPassed = timeDifference / (1000 * 60 * 60); // Convert to hours
  const daysPassed = timeDifference / (1000 * 60 * 60 * 24); // Convert to days

  if (minutesPassed < 1) {
    return "just now";
  } else if (hoursPassed < 1) {
    return `${Math.floor(minutesPassed)}m`;
  } else if (hoursPassed < 24) {
    return `${Math.floor(hoursPassed)}h`;
  } else {
    return `${Math.floor(daysPassed)}d`;
  }
}

export const formatTimestamp = (timestamp: string) => {
  const date = new Date(timestamp);
  const diffInMinutes = Math.floor((Date.now() - date.getTime()) / 60000);

  if (diffInMinutes === 0) return "Just now";
  if (diffInMinutes === 1) return "1 min ago";
  if (diffInMinutes < 60) return `${diffInMinutes} min ago`;

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours === 1) return "1 hr ago";
  if (diffInHours < 24) return `${diffInHours} hrs ago`;

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays === 1) return "1 day ago";
  if (diffInDays < 7) return `${diffInDays} days ago`;

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear()).slice(-2);

  return `${day}.${month}.${year}`;
};
